export default {
  moneySymbol: '₫',
  tableForm: {
    search: 'Tìm kiếm',
    reset: 'Đặt lại',
    submit: 'Gửi đi',
    collapsed: 'Mở rộng',
    expand: 'Thu gọn',
    inputPlaceholder: 'Nhập dữ liệu',
    selectPlaceholder: 'Vui lòng chọn',
  },
  alert: {
    clear: 'Bỏ chọn',
    selected: 'đã chọn',
    item: 'mục',
  },
  pagination: {
    total: {
      range: ' ',
      total: 'trên',
      item: 'bản ghi',
    },
  },
  tableToolBar: {
    leftPin: 'Ghim trái',
    rightPin: 'Ghim phải',
    noPin: 'Bỏ ghim',
    leftFixedTitle: 'Cố định trái',
    rightFixedTitle: 'Cố định phải',
    noFixedTitle: 'Chưa cố định',
    reset: 'Làm lại',
    columnDisplay: 'Cột hiển thị',
    columnSetting: 'Cấu hình',
    fullScreen: 'Chế độ toàn màn hình',
    exitFullScreen: 'Thoát chế độ toàn màn hình',
    reload: 'Đặt lại',
    density: 'Mật độ hiển thị',
    densityDefault: 'Mặc định',
    densityLarger: 'Mặc định',
    densityMiddle: 'Trung bình',
    densitySmall: 'Chật',
  },
};
